import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { EffectivenessTag } from '@/common/model/recommend/aiTag'

import { IconType } from '@/components/view/atoms/icon/Icon'
import IconText from '@/components/view/atoms/icon/IconText'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

import AITagEffectivenessListRow from './AITagEffectivenessListRow'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem float={float} {...rectProps(0)}>
        <Text size={12} color={TextColor.SECONDARY}>
          タグ名
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>
          タグカテゴリ
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text size={12} color={TextColor.SECONDARY}>
          効果スコア
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text size={12} color={TextColor.SECONDARY}>
          商品数
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text size={12} color={TextColor.SECONDARY}>
          クリック数
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <Text size={12} color={TextColor.SECONDARY}>
          クリック率
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <Text size={12} color={TextColor.SECONDARY}>
          閲覧数
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(7)}>
        <Text size={12} color={TextColor.SECONDARY}>
          購入数
        </Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(8)}>
        <IconText
          direction='horizon'
          iconType={IconType.INBOX}
          text='CVR'
          textSize={12}
          textColor={TextColor.CRITICAL}
          color={TextColor.CRITICAL}
        />
      </TableHeadItem>
    </>
  )
}

interface Props {
  tags: EffectivenessTag[]
}

const COLUMN_LENGTH = 9

const AITagEffectivenessListTable = ({ tags }: Props) => {
  const listFollowProps = useListScrollFollow(COLUMN_LENGTH)
  const { header } = listFollowProps

  const maxCvr = Math.max(...tags.map((t) => t.cvr), 1)
  const maxCtr = Math.max(...tags.map((t) => t.ctr), 1)

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {tags.map((tag, i) => (
            <AITagEffectivenessListRow
              key={tag.id}
              tag={tag}
              rank={i}
              maxCvr={maxCvr}
              maxCtr={maxCtr}
            />
          ))}
        </>
      }
      condition={{ page: 1, perPage: tags.length || 1 }}
      onUpdatePage={() => {}}
      total={tags.length}
    />
  )
}

export default AITagEffectivenessListTable
